<template>
<v-list-tile v-if="hasTrackerUrls" @click="track">
	<v-list-tile-action>
		<v-icon small>fa-compass</v-icon>
	</v-list-tile-action>
	<v-list-tile-content>
		<v-list-tile-title small>Track</v-list-tile-title>
		<v-list-tile-sub-title small>View real-time locations associated with this entry</v-list-tile-sub-title>
	</v-list-tile-content>
</v-list-tile>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmRowActionTracker",

	props: {
		row: Object
	},

	computed: {
		...Vuex.mapState({ user: (state) => state.user.user }),

		trackerUrls () {
			const trackers = this.row.entity.deepProp("trackerUrl");
			return trackers;
		},

		hasTrackerUrls () {
			return this.trackerUrls.length;
		}
	},

	methods: {
		track () {
			// TODO
			console.log("TRACK ACTION HANDLER");
		}
	}
};

</script>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionTracker.vue